import React from 'react';
import { observer } from 'mobx-react';
import ReceivingHistoryLogListTemplate from './ReceivingHistoryLogListTemplate';
import { ReceivingHistoryLogViewStore } from 'modules/receiving/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ReceivingHistoryLogViewStore(rootStore), 'receivingHistoryLogViewStore')
@observer
class ReceivingHistoryLogList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ReceivingHistoryLogListTemplate {...this.props} headerCell={[]} />;
	}
}

export default ReceivingHistoryLogList;
